import { render, staticRenderFns } from "./VehicleGarageEdit.vue?vue&type=template&id=6479ee82&lang=pug"
import script from "./VehicleGarageEdit.vue?vue&type=script&lang=js"
export * from "./VehicleGarageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports